import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link
} from "react-router-dom";
import Index from "./pages/index";
import Mapping from "./pages/Mapping";
import Containers from "./pages/Containers";
import Jobs from "./pages/Jobs";
import KYCL from "./pages/KYCL";
import LiveLocation from "./pages/LiveLocation";
import Equipment from "./pages/Equipment";
import { useEffect } from "react";
import StackLayout from './pages/3d/stacksLayout';
import DynamicStacks from './pages/3d/dynamicStacks';
import Login from "./Login";
import Logout from "./Logout";
import PrivateRoute from "./PrivateRoute";
import ContainersHistory from "./pages/ContainersHistory";
import Stacks from "./pages/Stacks";
import Strategy from "./pages/Strategy";
import StrategyAdd from "./pages/StrategyAdd";
import StrategyWarehouse from "./pages/StrategyWarehouse";
import GoogleMap from "./pages/GoogleMap";
import StrategyUpdate from "./pages/StrategyUpdate";
import LSCReport from "./pages/LSCReport";
import CHEUtilization from "./pages/CHEUtilization";
import CheReport from "./pages/CHEReport";
import ReportChart from "./pages/ReportChart";
import GoogleMapCntrLoc from "./pages/GoogleMapCntrLoc";
import EirReport from "./pages/EirReport";
import EIRMain from "./pages/EIRMain";
import GoogleMapComponent_v2 from "./pages/GoogleMapCntrLocV2";
import LiveItvTracking from "./pages/LiveItvTracking";
import StacksV2 from "./pages/StacksV2";
import Profile from "./pages/Profile";
import ContainerInventory from "./pages/ContainerInventory";
// GoogleMapComponent_v2

export default function App() {
  const initialTheme = sessionStorage.getItem("myTheme") === "true";
  useEffect(() => {
      const coreCss = document.querySelector(".template-customizer-core-css");
      const themeCss = document.querySelector(".template-customizer-theme-css");

      if (initialTheme) {
        document.documentElement.setAttribute("data-style", "dark");
        if (coreCss && themeCss) {
          coreCss.setAttribute("href", "/assets/vendor/css/rtl/core-dark.css");
          themeCss.setAttribute(
            "href",
            "/assets/vendor/css/rtl/theme-default-dark.css"
          );
        }
      } else {
        document.documentElement.setAttribute("data-style", "light");
        if (coreCss && themeCss) {
          coreCss.setAttribute("href", "/assets/vendor/css/rtl/core.css");
          themeCss.setAttribute(
            "href",
            "/assets/vendor/css/rtl/theme-default.css"
          );
        }
      }
  }, []);
  return (
    <Router>
      <div>

        <Routes>
          <Route  path="/login" element={<Login /> } />
          <Route  path="/logout" element={<Logout /> } />
          <Route  path="/Profile" element={<Profile /> } />
          
          <Route  path="/" element={<PrivateRoute><Index /></PrivateRoute> } />
          <Route  path="/strategy/add" element={<PrivateRoute><StrategyAdd /></PrivateRoute> } />
          <Route  path="/strategy/update/:id" element={<PrivateRoute><StrategyUpdate /></PrivateRoute> } />
          <Route  path="/strategy" element={<PrivateRoute><Strategy /></PrivateRoute> } />
          <Route  path="/warehouse_jobs" element={<PrivateRoute><StrategyWarehouse /></PrivateRoute> } />
          <Route  path="/containers" element={<PrivateRoute><Containers /></PrivateRoute> } />
          <Route  path="/container/inventory" element={<PrivateRoute><ContainerInventory /></PrivateRoute> } />
          <Route  path="/container-history" element={<PrivateRoute><ContainersHistory /></PrivateRoute> } />
          <Route  path="/jobs" element={<PrivateRoute><Jobs /></PrivateRoute> } />
          <Route  path="/kycl" element={<PrivateRoute><KYCL /></PrivateRoute> } />
          <Route  path="/live-location" element={<PrivateRoute><LiveLocation /></PrivateRoute> } />
          <Route  path="/equipment" element={<PrivateRoute><Equipment /></PrivateRoute> } />

          <Route path="/stackView/:id?" element={<PrivateRoute><StackLayout /></PrivateRoute> }/>
          <Route path="/stackView/dynamic/:id?" element={<PrivateRoute><DynamicStacks /></PrivateRoute> }/>

          <Route path="/Stacks/v2" element={<PrivateRoute><StacksV2 /></PrivateRoute> }/>
          <Route  path="/mapping" element={<PrivateRoute><Mapping /></PrivateRoute> } />

          <Route path="/Stacks" element={<PrivateRoute><Stacks /></PrivateRoute> }/>
          <Route path="/g_map" element={<PrivateRoute><GoogleMap /></PrivateRoute> }/>
          <Route path="liveItvTracking" element={<PrivateRoute><LiveItvTracking/></PrivateRoute>}/>
          <Route path="/g_map_cntr" element={<PrivateRoute><GoogleMapCntrLoc /></PrivateRoute> }/>
          <Route path="/reports/long-standing-container" element={<PrivateRoute ><LSCReport /></PrivateRoute>} />
          <Route path="/reports/che-utilization" element={<PrivateRoute ><CHEUtilization /></PrivateRoute>} />
          <Route path="/che-report" element={<PrivateRoute><CheReport/></PrivateRoute>}/>
          <Route path="/report-chart" element={<PrivateRoute><ReportChart/></PrivateRoute>}/>
          <Route path="/eir-report" element={<PrivateRoute><EirReport/></PrivateRoute>} />
          <Route path="/eir-main" element={<PrivateRoute><EIRMain/></PrivateRoute>} />
          <Route path="/map_v2" element={<PrivateRoute><GoogleMapComponent_v2/></PrivateRoute>} />
        
          {/* GoogleMapComponent_v2 */}
        </Routes>

      </div>
    </Router>

  );
}